export default __webpack_public_path__ + "static/media/destiny.8ce1bec8.mp3";